import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "../style/Result.css";

const Result = () => {
const { cid, date: paramDate, testName } = useParams(); // <-- get params from URL
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // You can later fetch empName & date from employees API if needed
  const [empName, setEmpName] = useState("");
  const [date, setDate] = useState("");



  const pdfUrl = `https://assessment.tetekniqx.com//api/download-test-result-pdf/${cid}/${paramDate}/${encodeURIComponent(testName)}`;



useEffect(() => {
  const fetchData = async () => {
    try {
      const response = await fetch(
        `https://assessment.tetekniqx.com/api/results/${cid}/${paramDate}/${testName}/`
      );
      if (!response.ok) throw new Error("Failed to fetch results");
      const data = await response.json();

      setDatas(data);

      if (data.length > 0) {
        setEmpName(data[0].candidate_name || `Candidate ${cid}`);
        setDate(data[0].created_at);
      }
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };
  fetchData();
}, [cid, testName, paramDate]);



  if (loading) return <p>Loading results...</p>;
  if (error) return <p style={{ color: "red" }}>Error: {error}</p>;

  return (
    <div className="result__container">
      <div className="result__container">
        <main className="result__main-content">
          <h2 className="result__title">{testName} Test Result</h2>

          <a href={pdfUrl} className="result__btn">
            Download PDF
          </a>

          {datas.length > 0 ? (
            datas.map((data, index) => (
              <div key={data.id || index} className="result__question-card">
                <h3 className="result__question-title">
                  <strong>Question {index + 1}:</strong> {data.q1}
                </h3>
                <ul className="result__options-list">
                  <li className="result__option-item">{data.o1}</li>
                  <li className="result__option-item">{data.o2}</li>
                  <li className="result__option-item">{data.o3}</li>
                  <li className="result__option-item">{data.o4}</li>
                  <li className="result__option-item">
                    <strong>Correct Answer:</strong> {data.a1}
                  </li>
                  <li className="result__option-item">
                    <strong>Selected Answer:</strong> {data.s1}
                  </li>
                </ul>
              </div>
            ))
          ) : (
            <p>No results found for this candidate/test.</p>
          )}
        </main>
      </div>
    </div>
  );
};

export default Result;
